import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import ShieldIcon from '@mui/icons-material/Shield';

interface SuperAdminBadgeProps {
  showText?: boolean;
}

/**
 * Componente que muestra un distintivo de SuperAdmin cuando el usuario tiene este rol
 */
const SuperAdminBadge: React.FC<SuperAdminBadgeProps> = ({ showText = true }) => {
  const { isSuperAdmin } = useSelector((state: RootState) => state.auth);
  
  if (!isSuperAdmin) return null;
  
  return (
    <Tooltip title="Usuario SuperAdmin con acceso total al sistema">
      <Chip
        icon={<ShieldIcon />}
        label={showText ? "SuperAdmin" : undefined}
        color="error"
        size="small"
        sx={{ 
          fontWeight: 'bold',
          ml: 1
        }}
      />
    </Tooltip>
  );
};

export default SuperAdminBadge; 